export default (quota) => {
  const quotaInGb = quota / Math.pow(1024, 3)

  if (quotaInGb >= 1024) return "Ilimitado"

  const formattedQuota = Math.floor(quotaInGb * 100) / 100

  return Number.isInteger(formattedQuota)
    ? `${formattedQuota}GB`
    : `${formattedQuota.toFixed(2).replace(".", ",")}GB`
}



// WEBPACK FOOTER //
// ./src/services/utils/convertQuotaBytesTo.js